/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { TaskV2 } from '../model/taskV2';
// @ts-ignore
import { TasksPaginatedResponse } from '../model/tasksPaginatedResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class TasksVcdrService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Get Task info for a specific VCDR Task in given org
     * Get Task info for a specific VCDR Task in given org
     * @param orgId Organization identifier
     * @param taskId Task identifier
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getVcdrTaskV2(orgId: string, taskId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<TaskV2>;
    public getVcdrTaskV2(orgId: string, taskId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskV2>>;
    public getVcdrTaskV2(orgId: string, taskId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskV2>>;
    public getVcdrTaskV2(orgId: string, taskId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling getVcdrTaskV2.');
        }
        if (taskId === null || taskId === undefined) {
            throw new Error('Required parameter taskId was null or undefined when calling getVcdrTaskV2.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcdr/org/${this.configuration.encodeParam({name: "orgId", value: orgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/tasks/${this.configuration.encodeParam({name: "taskId", value: taskId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/v2`;
        return this.httpClient.request<TaskV2>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all VCDR Tasks in given org
     * Get all VCDR Tasks in given org
     * @param orgId Organization identifier
     * @param sortByOrder Sort the properties by this order
     * @param sortBy Sort the tasks by this column
     * @param taskState 
     * @param vcdsServiceType VCDS Service Type
     * @param resourceType Task Resource Type
     * @param taskType Task Type
     * @param taskSubType Task Sub Type
     * @param from Time at which task was created
     * @param to Time at which task was closed
     * @param paginate Paginate the records
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getVcdrTasksV2(orgId: string, sortByOrder: 'ASC' | 'DESC', sortBy: 'orgId' | 'orgName' | 'orgType' | 'serviceType' | 'vcdsServiceType' | 'state' | 'resourceType' | 'taskType' | 'taskSubType' | 'startTime' | 'endTime' | 'createdBy' | 'progressPercent', taskState?: Array<'QUEUED' | 'IN_PROGRESS' | 'DONE' | 'FAILED' | 'CANCELING' | 'CANCELED'>, vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', resourceType?: 'NONE' | 'DEPLOYMENT' | 'AWS_ACCOUNT' | 'REQUEST_ACCESS' | 'SUBSCRIPTION' | 'RELEASE' | 'RANSOMWARE_RECOVERY_DEPLOYMENT' | 'VMCFS_DEPLOYMENT' | 'SEED_OAUTH_APP' | 'DISCONNECTED_DEPLOYMENT' | 'MONITOR', taskType?: 'DEPLOYMENT' | 'SEED-OAUTH-APP' | 'SUBSCRIPTION' | 'RANSOMWARE-RECOVERY' | 'RELEASE' | 'MAINTENANCE' | 'ACCESS' | 'MIGRATE' | 'RELEASE-CAPABILITY' | 'BILLING-PIPELINE-REFRESH' | 'DATASTORE' | 'CLOUD-PAIRING' | 'VMC-POOL' | 'DISCONNECTED-DEPLOYMENT' | 'RESOURCE-POOL', taskSubType?: 'ACTIVATE' | 'DEACTIVATE' | 'UPGRADE' | 'CREATE' | 'CREATE-IMPLICIT' | 'DELETE' | 'UPDATE' | 'CREATE-OD' | 'CANCEL' | 'ADD' | 'ENTER' | 'EXIT' | 'REQUEST' | 'ORG' | 'UPDATE-PROPERTIES' | 'COPY-CREDENTIALS' | 'ROTATE-CREDENTIALS' | 'UPDATE-ACCESS-LIST' | 'SCHEDULE' | 'IMPORT' | 'CREATE-CDVX' | 'CREATE-DATASTORE' | 'DELETE-DATASTORE' | 'AUTHORIZE' | 'LINK' | 'UNLINK' | 'ASSIGN' | 'UNASSIGN', from?: string, to?: string, paginate?: boolean, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<TasksPaginatedResponse>;
    public getVcdrTasksV2(orgId: string, sortByOrder: 'ASC' | 'DESC', sortBy: 'orgId' | 'orgName' | 'orgType' | 'serviceType' | 'vcdsServiceType' | 'state' | 'resourceType' | 'taskType' | 'taskSubType' | 'startTime' | 'endTime' | 'createdBy' | 'progressPercent', taskState?: Array<'QUEUED' | 'IN_PROGRESS' | 'DONE' | 'FAILED' | 'CANCELING' | 'CANCELED'>, vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', resourceType?: 'NONE' | 'DEPLOYMENT' | 'AWS_ACCOUNT' | 'REQUEST_ACCESS' | 'SUBSCRIPTION' | 'RELEASE' | 'RANSOMWARE_RECOVERY_DEPLOYMENT' | 'VMCFS_DEPLOYMENT' | 'SEED_OAUTH_APP' | 'DISCONNECTED_DEPLOYMENT' | 'MONITOR', taskType?: 'DEPLOYMENT' | 'SEED-OAUTH-APP' | 'SUBSCRIPTION' | 'RANSOMWARE-RECOVERY' | 'RELEASE' | 'MAINTENANCE' | 'ACCESS' | 'MIGRATE' | 'RELEASE-CAPABILITY' | 'BILLING-PIPELINE-REFRESH' | 'DATASTORE' | 'CLOUD-PAIRING' | 'VMC-POOL' | 'DISCONNECTED-DEPLOYMENT' | 'RESOURCE-POOL', taskSubType?: 'ACTIVATE' | 'DEACTIVATE' | 'UPGRADE' | 'CREATE' | 'CREATE-IMPLICIT' | 'DELETE' | 'UPDATE' | 'CREATE-OD' | 'CANCEL' | 'ADD' | 'ENTER' | 'EXIT' | 'REQUEST' | 'ORG' | 'UPDATE-PROPERTIES' | 'COPY-CREDENTIALS' | 'ROTATE-CREDENTIALS' | 'UPDATE-ACCESS-LIST' | 'SCHEDULE' | 'IMPORT' | 'CREATE-CDVX' | 'CREATE-DATASTORE' | 'DELETE-DATASTORE' | 'AUTHORIZE' | 'LINK' | 'UNLINK' | 'ASSIGN' | 'UNASSIGN', from?: string, to?: string, paginate?: boolean, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TasksPaginatedResponse>>;
    public getVcdrTasksV2(orgId: string, sortByOrder: 'ASC' | 'DESC', sortBy: 'orgId' | 'orgName' | 'orgType' | 'serviceType' | 'vcdsServiceType' | 'state' | 'resourceType' | 'taskType' | 'taskSubType' | 'startTime' | 'endTime' | 'createdBy' | 'progressPercent', taskState?: Array<'QUEUED' | 'IN_PROGRESS' | 'DONE' | 'FAILED' | 'CANCELING' | 'CANCELED'>, vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', resourceType?: 'NONE' | 'DEPLOYMENT' | 'AWS_ACCOUNT' | 'REQUEST_ACCESS' | 'SUBSCRIPTION' | 'RELEASE' | 'RANSOMWARE_RECOVERY_DEPLOYMENT' | 'VMCFS_DEPLOYMENT' | 'SEED_OAUTH_APP' | 'DISCONNECTED_DEPLOYMENT' | 'MONITOR', taskType?: 'DEPLOYMENT' | 'SEED-OAUTH-APP' | 'SUBSCRIPTION' | 'RANSOMWARE-RECOVERY' | 'RELEASE' | 'MAINTENANCE' | 'ACCESS' | 'MIGRATE' | 'RELEASE-CAPABILITY' | 'BILLING-PIPELINE-REFRESH' | 'DATASTORE' | 'CLOUD-PAIRING' | 'VMC-POOL' | 'DISCONNECTED-DEPLOYMENT' | 'RESOURCE-POOL', taskSubType?: 'ACTIVATE' | 'DEACTIVATE' | 'UPGRADE' | 'CREATE' | 'CREATE-IMPLICIT' | 'DELETE' | 'UPDATE' | 'CREATE-OD' | 'CANCEL' | 'ADD' | 'ENTER' | 'EXIT' | 'REQUEST' | 'ORG' | 'UPDATE-PROPERTIES' | 'COPY-CREDENTIALS' | 'ROTATE-CREDENTIALS' | 'UPDATE-ACCESS-LIST' | 'SCHEDULE' | 'IMPORT' | 'CREATE-CDVX' | 'CREATE-DATASTORE' | 'DELETE-DATASTORE' | 'AUTHORIZE' | 'LINK' | 'UNLINK' | 'ASSIGN' | 'UNASSIGN', from?: string, to?: string, paginate?: boolean, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TasksPaginatedResponse>>;
    public getVcdrTasksV2(orgId: string, sortByOrder: 'ASC' | 'DESC', sortBy: 'orgId' | 'orgName' | 'orgType' | 'serviceType' | 'vcdsServiceType' | 'state' | 'resourceType' | 'taskType' | 'taskSubType' | 'startTime' | 'endTime' | 'createdBy' | 'progressPercent', taskState?: Array<'QUEUED' | 'IN_PROGRESS' | 'DONE' | 'FAILED' | 'CANCELING' | 'CANCELED'>, vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', resourceType?: 'NONE' | 'DEPLOYMENT' | 'AWS_ACCOUNT' | 'REQUEST_ACCESS' | 'SUBSCRIPTION' | 'RELEASE' | 'RANSOMWARE_RECOVERY_DEPLOYMENT' | 'VMCFS_DEPLOYMENT' | 'SEED_OAUTH_APP' | 'DISCONNECTED_DEPLOYMENT' | 'MONITOR', taskType?: 'DEPLOYMENT' | 'SEED-OAUTH-APP' | 'SUBSCRIPTION' | 'RANSOMWARE-RECOVERY' | 'RELEASE' | 'MAINTENANCE' | 'ACCESS' | 'MIGRATE' | 'RELEASE-CAPABILITY' | 'BILLING-PIPELINE-REFRESH' | 'DATASTORE' | 'CLOUD-PAIRING' | 'VMC-POOL' | 'DISCONNECTED-DEPLOYMENT' | 'RESOURCE-POOL', taskSubType?: 'ACTIVATE' | 'DEACTIVATE' | 'UPGRADE' | 'CREATE' | 'CREATE-IMPLICIT' | 'DELETE' | 'UPDATE' | 'CREATE-OD' | 'CANCEL' | 'ADD' | 'ENTER' | 'EXIT' | 'REQUEST' | 'ORG' | 'UPDATE-PROPERTIES' | 'COPY-CREDENTIALS' | 'ROTATE-CREDENTIALS' | 'UPDATE-ACCESS-LIST' | 'SCHEDULE' | 'IMPORT' | 'CREATE-CDVX' | 'CREATE-DATASTORE' | 'DELETE-DATASTORE' | 'AUTHORIZE' | 'LINK' | 'UNLINK' | 'ASSIGN' | 'UNASSIGN', from?: string, to?: string, paginate?: boolean, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling getVcdrTasksV2.');
        }
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getVcdrTasksV2.');
        }
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getVcdrTasksV2.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        if (taskState) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                [...taskState].join(COLLECTION_FORMATS['csv']), 'task-state');
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vcdsServiceType, 'vcds-service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>resourceType, 'resource-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>taskType, 'task-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>taskSubType, 'task-sub-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>from, 'from');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>to, 'to');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>paginate, 'paginate');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcdr/org/${this.configuration.encodeParam({name: "orgId", value: orgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/tasks/v2`;
        return this.httpClient.request<TasksPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
